import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  forwardRef,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { NgTemplateOutlet } from '@angular/common';
import { StepComponent } from './step.component';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';

export interface StepChangedEvent {
  index: number;
  step: StepComponent;
}
@Component({
  selector: 'seech-stepper',
  standalone: true,
  imports: [CommonModule, NgTemplateOutlet, CdkStepperModule, MdbRippleModule],
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  providers: [{ provide: CdkStepper, useExisting: forwardRef(() => StepperComponent) }],
})
export class StepperComponent extends CdkStepper implements OnInit {
  @Input() headerClass = '';
  @Input() id: string | number | null | undefined = null;
  @HostBinding('attr.id') elementId = this.id;
  @Input() showHeader = true;
  @Input() headerBackgroundColor = '#F9FAFB';
  @Output() stepChanged: EventEmitter<StepChangedEvent> = new EventEmitter<StepChangedEvent>();

  selectStep(index: number): void {
    // Don't allow selection of disabled steps
    if (this.isStepDisabled(index)) {
      return;
    }
    
    this.selectedIndex = index;
    this.stepChanged.emit({
      index: index,
      step: this.steps[index] as StepComponent,
    });
  }

  ngOnInit(): void {
    this.elementId = this.id ?? '';
  }

  isActive(index: number) {
    return this.selectedIndex === index;
  }

  isStepDisabled(index: number): boolean {
    const step = this.steps[index] as StepComponent;
    return step?.disabled === true;
  }

  computeId(prefix: string): string | null {
    return '' + this.id ? `${prefix}-${this.id}` : null;
  }
}